<template>
  <div class="donate-page">

    <section class="donate-hero">
      <div class="donate-hero-inner">
        <h1 class="donate-h1">Donate to our programs.</h1>
        <p class="donate-hero-sub">
          Every contribution — cash or kind — goes directly to the people who need it most.
          No admin bloat. No middle layer. Straight to the community.
        </p>
      </div>
    </section>

    <section class="donate-body">
      <div class="donate-body-inner">

        <!-- Donate in kind -->
        <div class="donate-row">
          <div class="donate-row-left">
            <span class="donate-num">01</span>
            <h2 class="donate-title">Donate in kind</h2>
            <span class="donate-tag">Laptops · Books · Tech gear</span>
          </div>
          <div class="donate-row-content">
            <p>
              We accept laptops, books, and other tech equipment for community members 
              who need them. If you have something to give, reach out and we'll sort 
              the logistics together.
            </p>
            <a class="donate-link" href="mailto:info@nexascale.org">
              info@nexascale.org →
            </a>
          </div>
        </div>

        <!-- Donate in cash -->
        <div class="donate-row donate-row--warm">
          <div class="donate-row-left">
            <span class="donate-num">02</span>
            <h2 class="donate-title">Donate in cash</h2>
            <span class="donate-tag">Bank transfer</span>
          </div>
          <div class="donate-row-content">
            <p>
              Every cash donation directly funds our programs — refurbished laptops 
              for members without devices, scholarships for paid programs, AI education 
              in Nigerian secondary schools, and the infrastructure that keeps 11,000 
              people connected.
            </p>
            <button class="donate-btn" data-bs-toggle="modal" data-bs-target="#bankModal">
              See our bank details →
            </button>
          </div>
        </div>

      </div>
    </section>

    <!-- BANK MODAL -->
    <div class="modal fade" id="bankModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content donate-modal">
          <div class="modal-header donate-modal-head">
            <div>
              <p class="donate-modal-eyebrow">Donate to NexaScale</p>
              <h5 class="donate-modal-title">Bank account details</h5>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body donate-modal-body">
            <p class="donate-modal-note">
              Use your full name as the payment reference. We accept NGN and USD.
              Thank you — genuinely.
            </p>
            <div class="bank-accounts">

              <div class="bank-account">
                <p class="bank-flag">🇳🇬 NGN — Zenith Bank</p>
                <table class="bank-table">
                  <tr><td class="bank-label">Account Holder</td><td>NEXASCALE TECHNOLOGY ADVOCATES INITIATIVE</td></tr>
                  <tr><td class="bank-label">Account Number</td><td class="bank-num">1311669784</td></tr>
                  <tr><td class="bank-label">Bank</td><td>Zenith Bank PLC</td></tr>
                  <tr><td class="bank-label">Currency</td><td>NGN</td></tr>
                </table>
              </div>

              <div class="bank-account">
                <p class="bank-flag">🇺🇸 USD — Zenith Bank</p>
                <table class="bank-table">
                  <tr><td class="bank-label">Account Holder</td><td>NEXASCALE TECHNOLOGY ADVOCATES INITIATIVE</td></tr>
                  <tr><td class="bank-label">Account Number</td><td class="bank-num">5075874578</td></tr>
                  <tr><td class="bank-label">Bank</td><td>Zenith Bank PLC</td></tr>
                  <tr><td class="bank-label">Currency</td><td>USD</td></tr>
                </table>
              </div>

              <div class="bank-account">
                <p class="bank-flag">🇳🇬 NGN — Moniepoint</p>
                <table class="bank-table">
                  <tr><td class="bank-label">Account Holder</td><td>NEXASCALE TECHNOLOGY ADVOCATES INITIATIVE</td></tr>
                  <tr><td class="bank-label">Account Number</td><td class="bank-num">7033610860</td></tr>
                  <tr><td class="bank-label">Bank</td><td>Moniepoint MFB</td></tr>
                  <tr><td class="bank-label">Currency</td><td>NGN</td></tr>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.donate-page {
  min-height: var(--pageheight, 100vh);
  margin-top: 80px;
  text-align: left;
}
.donate-page * { box-sizing: border-box; }
.donate-page p, .donate-page h1, .donate-page h2 { text-align: left; }

/* HERO */
.donate-hero {
  background: #191616;
  padding: 100px 7% 80px;
}
.donate-hero-inner { max-width: 680px; }
.donate-h1 {
  font-size: clamp(2.6rem, 6vw, 5.5rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.0;
  color: #ffffff;
  margin: 0 0 24px;
  word-break: break-word;
}
.donate-hero-sub {
  font-size: 1rem;
  line-height: 1.75;
  color: rgba(255,255,255,0.5);
  margin: 0;
}

/* BODY */
.donate-body {
  background: #ffffff;
}
.donate-body-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 7%;
}

/* ROWS */
.donate-row {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 60px;
  align-items: start;
  padding: 72px 0;
  border-bottom: 1px solid #e8e4e0;
}
.donate-row--warm {
  background: #FFFBEB;
  margin: 0 -7%;
  padding: 72px 7%;
  border-bottom: none;
}

.donate-row-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: sticky;
  top: 100px;
}
.donate-num {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  color: #FFB812;
  display: block;
}
.donate-title {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  color: #191616;
  margin: 0;
}
.donate-tag {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #c0bbb8;
}

.donate-row-content { min-width: 0; }
.donate-row-content p {
  font-size: 0.97rem;
  line-height: 1.8;
  color: #555250;
  margin: 0 0 24px;
}
.donate-row-content a { color: #FF9914; }

.donate-link {
  display: inline-block;
  font-size: 0.88rem;
  font-weight: 700;
  color: #191616;
  text-decoration: none;
  border-bottom: 2px solid #FFB812;
  padding-bottom: 2px;
  transition: color 0.2s;
}
.donate-link:hover { color: #FF9914; }

.donate-btn {
  display: inline-block;
  background: #191616;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.88rem;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s;
}
.donate-btn:hover { background: #333; }

/* MODAL */
.donate-modal {
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}
.donate-modal-head {
  padding: 28px 32px 20px;
  border-bottom: 1px solid #e8e4e0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.donate-modal-eyebrow {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #FFB812;
  margin-bottom: 6px;
}
.donate-modal-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #191616;
  margin: 0;
}
.donate-modal-body { padding: 28px 32px 36px; }
.donate-modal-note {
  font-size: 0.88rem;
  color: #888480;
  margin-bottom: 28px;
  line-height: 1.65;
  font-style: italic;
}
.bank-accounts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.bank-account {
  border: 1px solid #e8e4e0;
  border-radius: 10px;
  padding: 24px;
}
.bank-flag {
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #191616;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #FFB812;
  display: inline-block;
}
.bank-table { width: 100%; border-collapse: collapse; }
.bank-table tr { border-bottom: 1px solid #f0ece8; }
.bank-table tr:last-child { border-bottom: none; }
.bank-table td { padding: 8px 0; font-size: 0.85rem; color: #444; vertical-align: top; }
.bank-label {
  font-size: 0.68rem;
  font-weight: 700;
  color: #aaa8a4;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  width: 38%;
  padding-right: 12px;
}
.bank-num { font-weight: 800; font-size: 1rem; color: #191616; letter-spacing: 0.04em; }

/* RESPONSIVE */
@media (max-width: 900px) {
  .donate-row {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 52px 0;
  }
  .donate-row--warm { padding: 52px 5%; margin: 0 -5%; }
  .donate-row-left { position: static; }
  .donate-hero { padding: 80px 5% 60px; }
  .donate-body-inner { padding: 0 5%; }
  .bank-accounts { grid-template-columns: 1fr; }
  .donate-modal-head, .donate-modal-body { padding-left: 20px; padding-right: 20px; }
}
</style>